var FormSyncBuilder = /** @class */ (function () {
    function FormSyncBuilder() {
    }
    FormSyncBuilder.prototype.build = function (rawData, state, requestId, trigger) {
        var formData = {
            id: 0,
            state: state,
            data: rawData,
            requestId: requestId
        };
        var formSync = {
            formData: formData,
            triggers: trigger,
            isFormValid: false
        };
        return formSync;
    };
    return FormSyncBuilder;
}());
export { FormSyncBuilder };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS1zeW5jLWJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmb3JtLXN5bmMtYnVpbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQTtJQUFBO0lBZUEsQ0FBQztJQWRVLCtCQUFLLEdBQVosVUFBYSxPQUFlLEVBQUUsS0FBa0IsRUFBRSxTQUFpQixFQUFFLE9BQTBCO1FBQzNGLElBQUksUUFBUSxHQUFhO1lBQ3JCLEVBQUUsRUFBRSxDQUFDO1lBQ0wsS0FBSyxFQUFFLEtBQUs7WUFDWixJQUFJLEVBQUUsT0FBTztZQUNiLFNBQVMsRUFBRSxTQUFTO1NBQ3ZCLENBQUM7UUFDRixJQUFJLFFBQVEsR0FBYTtZQUNyQixRQUFRLEVBQUUsUUFBUTtZQUNsQixRQUFRLEVBQUUsT0FBTztZQUNqQixXQUFXLEVBQUUsS0FBSztTQUNyQixDQUFDO1FBQ0YsT0FBTyxRQUFRLENBQUM7SUFDcEIsQ0FBQztJQUNMLHNCQUFDO0FBQUQsQ0FBQyxBQWZELElBZUMifQ==